"use strict";
/*
 * Created on 29.01.2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * @author Tomáš Leity
 */


var ReplePromoManagementDetailFilterConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(ReplePromoManagementDetailFilterConverter, _DataObjectConverter_);

  function ReplePromoManagementDetailFilterConverter() {
    _classCallCheck(this, ReplePromoManagementDetailFilterConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(ReplePromoManagementDetailFilterConverter).apply(this, arguments));
  }

  return ReplePromoManagementDetailFilterConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.ReplePromoManagementDetailFilterConverter = ReplePromoManagementDetailFilterConverter;